import logo from "../../assets/logo/logo3.png";

export default function Logo({
  size = 96,
  radius = 24,
  showText = true,
}) {
  return (
    <div className="logoWrap">
      <img
        src={logo}
        alt="Chauffy Logo"
        className="logoImage"
        style={{
          width: size,
          height: size,
          borderRadius: radius,
        }}
      />

      {showText && (
        <div className="logoText">
          <div className="logoName">Chauffy</div>
          <div className="logoSub">Best Drivers App</div>
        </div>
      )}
    </div>
  );
}
